/* Douga Douga – panier : proposer l'abonnement pour réduire la facture (tiroir + page panier) */
(() => {
  'use strict';
  const CFG = window.DD_GIFT || null;
  const SUBS = (CFG && CFG.subs) || {};
  if (!CFG || !Object.keys(SUBS).length) return;
  const SH = window.Shopify || {};
  const RATE = (SH.currency && parseFloat(SH.currency.rate)) || 1;
  const CUR = (SH.currency && SH.currency.active) || 'EUR';
  const $ = (s, r = document) => r.querySelector(s);
  const MF = CFG.moneyFormat && (!CFG.shopCurrency || CFG.shopCurrency === CUR) ? CFG.moneyFormat : null;
  const grp = (s, th, dec) => { const [i, d] = s.split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? dec + d : ''); };
  const fmt = (c) => {
    const v = Math.round(c), n2 = (v / 100).toFixed(2), n0 = String(Math.round(v / 100));
    if (MF) {
      const map = { amount: grp(n2, ',', '.'), amount_no_decimals: grp(n0, ',', ''), amount_with_comma_separator: grp(n2, '.', ','), amount_no_decimals_with_comma_separator: grp(n0, '.', ''), amount_with_space_separator: grp(n2, ' ', ','), amount_with_apostrophe_separator: grp(n2, "'", '.') };
      return MF.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => map[k] || map.amount_with_comma_separator).replace(/<[^>]*>/g, '');
    }
    return (v / 100).toLocaleString('fr-FR', { style: 'currency', currency: CUR });
  };
  const memGet = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const memSet = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };
  const ICON_SUB = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 0 1-15.5 6.2M3 12A9 9 0 0 1 18.5 5.8"/><path d="M18 2v4h-4M6 22v-4h4"/></svg>';
  const ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg>';

  function toast(html, ms = 3200) {
    const t = document.createElement('div');
    t.className = 'dd-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<i>' + ICON_SUB + '</i><span>' + html + '</span>';
    document.body.appendChild(t);
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('show')));
    setTimeout(() => { t.classList.remove('show'); setTimeout(() => t.remove(), 700); }, ms);
  }
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  function cartReq(url, body) {
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Erreur'); return j; }));
  }
  function silentRender(resp) {
    if (!resp || !resp.sections) return;
    const inner = (html, sel) => { if (!html) return null; const d = new DOMParser().parseFromString(html, 'text/html'); const el = d.querySelector(sel); return el ? el.innerHTML : null; };
    const dr = document.querySelector('cart-drawer');
    const list = dr && typeof dr.getSectionsToRender === 'function' ? dr.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
    list.forEach((s) => {
      const el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      const h = inner(resp.sections[s.id], s.selector || '.shopify-section');
      if (el && h != null) el.innerHTML = h;
    });
    if (dr) {
      const ov = dr.querySelector('#CartDrawer-Overlay');
      if (ov && typeof dr.close === 'function') ov.addEventListener('click', dr.close.bind(dr));
      dr.classList.toggle('is-empty', resp.item_count === 0);
    }
  }

  /* même règle que la barre cadeau : seuls les achats à l'unité comptent pour la gourde offerte */
  const isElig = (pid) => (CFG.eligible || []).indexOf(Number(pid)) > -1;
  function giftState(cart) {
    const T = Math.round(CFG.threshold * RATE);
    let elig = 0, giftIn = 0, giftUnit = 0;
    (cart.items || []).forEach((i) => {
      if (i.selling_plan_allocation) return;
      if (i.variant_id === CFG.gift) { giftIn += i.quantity; giftUnit = i.original_price; }
      if (isElig(i.product_id)) elig += i.original_line_price;
    });
    if (giftIn > 0) elig -= giftUnit;
    elig = Math.max(0, elig);
    return { T, elig, giftIn, ok: elig >= T };
  }

  function plan(cart) {
    const st = giftState(cart);
    const giftFree = st.ok && st.giftIn > 0;
    let keepGift = giftFree ? 1 : 0;
    const lines = [];
    let save = 0, done = 0, pct = 0, eligMoved = 0, giftLine = null;
    (cart.items || []).forEach((it) => {
      const a = it.selling_plan_allocation;
      if (a) { done += Math.max(0, ((a.compare_at_price || it.original_price) - a.price) * it.quantity); pct = Math.max(pct, (SUBS[it.variant_id] || {}).pct || 0); return; }
      if (it.variant_id === CFG.gift) giftLine = it;
      const s = SUBS[it.variant_id];
      if (!s || !s.sp || !(s.spp < it.original_price)) return;
      let n = it.quantity;
      if (it.variant_id === CFG.gift && keepGift) { n -= keepGift; keepGift = 0; } // la gourde offerte n'est pas convertie
      if (n <= 0) return;
      lines.push({ key: it.key, v: it.variant_id, q: it.quantity, n, sp: s.sp });
      save += (it.original_price - s.spp) * n;
      pct = Math.max(pct, s.pct || 0);
      if (isElig(it.product_id)) eligMoved += it.original_price * n;
    });
    const loseGift = giftFree && !!giftLine && st.elig - eligMoved < st.T;
    return { lines, save: Math.round(save), done: Math.round(done), pct: pct || 28, loseGift, giftLine };
  }

  async function convert(pl) {
    await cartReq('/cart/add.js', { items: pl.lines.map((l) => ({ id: l.v, quantity: l.n, selling_plan: l.sp })) });
    const up = {};
    pl.lines.forEach((l) => { up[l.key] = l.q - l.n; });
    if (pl.loseGift && pl.giftLine) { const k = pl.giftLine.key; up[k] = Math.max(0, (up[k] != null ? up[k] : pl.giftLine.quantity) - 1); }
    const resp = await cartReq('/cart/update.js', { updates: up });
    if (pl.loseGift) memSet('ddGiftAuto', '0');
    return resp;
  }

  let lastCart = null;
  function paint(scope, cart, onPage) {
    if (!scope) return;
    const ctas = $('.cart__ctas', scope);
    let box = $('.dd-su', scope);
    const pl = plan(cart);
    if (!ctas || cart.item_count === 0 || !((pl.lines.length && pl.save > 0) || pl.done > 0)) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('div');
      box.className = 'dd-su';
      box.setAttribute('aria-live', 'polite');
      ctas.parentNode.insertBefore(box, ctas);
      box.addEventListener('click', async (e) => {
        const b = e.target.closest('.dd-su__btn');
        if (!b || b.classList.contains('is-loading')) return;
        b.classList.add('is-loading');
        try {
          const fresh = await getCart();
          const p2 = plan(fresh);
          if (!p2.lines.length) { b.classList.remove('is-loading'); return; }
          const resp = await convert(p2);
          toast('<b>Abonnement activé</b> · ' + fmt(p2.save) + ' d’économie à chaque livraison');
          if (onPage) { location.reload(); return; }
          silentRender(resp);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dd-subup', cartData: resp });
          refresh();
        } catch (err) { toast(err.message || 'Une erreur est survenue'); b.classList.remove('is-loading'); }
      });
    }
    if (pl.lines.length && pl.save > 0) {
      box.classList.remove('is-on');
      box.innerHTML = '<div class="dd-su__hd"><span class="dd-su__ic">' + ICON_SUB + '</span><p><b>Réduisez votre facture de ' + fmt(pl.save) + '</b><span>Passez en abonnement −' + pl.pct + ' % : livré chaque mois, sans engagement.</span></p></div>' +
        (pl.loseGift ? '<p class="dd-su__note">La gourde offerte est réservée aux achats à l’unité : elle sera retirée du panier.</p>' : '') +
        '<button type="button" class="dd-su__btn">Passer en abonnement · <b>' + fmt(Math.max(0, cart.total_price - pl.save)) + '</b> <s>' + fmt(cart.total_price) + '</s></button>';
    } else {
      box.classList.add('is-on');
      box.innerHTML = '<div class="dd-su__hd"><span class="dd-su__ic">' + ICON_OK + '</span><p><b>Abonnement −' + pl.pct + ' % appliqué</b><span>Vous économisez ' + fmt(pl.done) + ' à chaque livraison, sans engagement.</span></p></div>';
    }
  }

  let busy = null;
  function refresh() {
    if (busy) return busy;
    busy = getCart().then((cart) => {
      lastCart = cart;
      const dr = document.querySelector('cart-drawer');
      if (dr) paint($('#CartDrawer', dr) || dr, cart, false);
      const page = document.getElementById('main-cart-footer');
      if (page) paint(page, cart, true);
    }).catch(() => {}).then(() => { busy = null; });
    return busy;
  }

  function init() {
    refresh();
    const dr = document.querySelector('cart-drawer');
    if (dr) {
      let t;
      new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(() => { if ($('.cart__ctas', dr) && !$('.dd-su', dr)) refresh(); }, 150);
      }).observe(dr, { childList: true, subtree: true });
    }
    const page = document.getElementById('main-cart-footer');
    if (page) {
      let t2;
      new MutationObserver(() => {
        clearTimeout(t2);
        t2 = setTimeout(() => { if ($('.cart__ctas', page) && !$('.dd-su', page)) refresh(); }, 150);
      }).observe(page, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'dd-subup') setTimeout(refresh, 120); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
